import { useParams } from "react-router-dom";
import "./singleRigcheck.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import "react-toastify/dist/ReactToastify.css";
import { onSnapshot } from "firebase/firestore";
import SubCheckModal from "../subCheckModal/SubCheckModal";

const SingleRigcheck = ({ check }) => {
  const navigate = useNavigate();
  let { agency } = useParams();
  agency = agency.replace(/\w\S*/g, (w) =>
    w.replace(/^\w/, (c) => c.toUpperCase())
  );
  // test data
  const disabledService = check.disabledService;
  const [failedValue, setFailedValue] = useState([]);
  const [completedToday, setCompletedToday] = useState([]);
  const [lastCheckedDate, setLastCheckedDate] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [hasChildChecks, setHasChildChecks] = useState(false);

  const handleCardClick = () => {
    // If this check has child checks, open the modal instead of navigating directly
    if (hasChildChecks) {
      setModalOpen(true);
    } else {
      // Otherwise navigate directly to the check
      navigate(`/${agency}/${check.id}`);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // const findPassOrFailItem = (answerData) =>
  //   answerData.find(
  //     (item) =>
  //       Array.isArray(item.value) &&
  //       item.value.length === 1 &&
  //       (item.value[0].toLowerCase() === "pass" ||
  //         item.value[0].toLowerCase() === "fail")
  //   );

  useEffect(() => {
    // Check if this rigcheck has child checks
    if (check.childCheckUrls && check.childCheckUrls.length > 0) {
      setHasChildChecks(true);
    } else {
      setHasChildChecks(false);
    }
  }, [check]);

  useEffect(() => {
    async function subscribeToRigcheckAnswers() {
      const fortyEightHoursAgo = new Date();
      fortyEightHoursAgo.setHours(fortyEightHoursAgo.getHours() - 48);

      try {
        const response = await fetch(
          "https://getcheckscompleted-b57g3ai2ua-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              agency: agency,
              check: check,
              includeSubchecks: true, // Include subchecks in the count
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData = await response.json();

        const checksCompletedToday = responseData.checksCompletedToday || [];
        const failedChecks = responseData.failedChecks || 0;
        
        // Check if lastSubmissionTime exists directly in response or in lastCompletedCheck
        const lastCompletedCheck = responseData.lastCompletedCheck || 
          (responseData.lastSubmissionTime ? { lastSubmissionTime: responseData.lastSubmissionTime } : null);

        setCompletedToday(checksCompletedToday.length);
        setFailedValue(failedChecks);
        
        // Set the last checked date if available
        if (lastCompletedCheck) {
          // Primary field is lastSubmissionTime (ISO string format)
          if (lastCompletedCheck.lastSubmissionTime) {
            setLastCheckedDate(new Date(lastCompletedCheck.lastSubmissionTime));
          } 
          // Fallbacks for other possible formats
          else if (lastCompletedCheck.createdAt) {
            if (lastCompletedCheck.createdAt.seconds) {
              // Handle Firestore timestamp format
              setLastCheckedDate(new Date(lastCompletedCheck.createdAt.seconds * 1000));
            } else {
              setLastCheckedDate(new Date(lastCompletedCheck.createdAt));
            }
          } else if (lastCompletedCheck.timestamp) {
            setLastCheckedDate(new Date(lastCompletedCheck.timestamp));
          } else if (lastCompletedCheck.date) {
            setLastCheckedDate(new Date(lastCompletedCheck.date));
          } else {
            // If the lastCompletedCheck itself is a timestamp or date string
            if (typeof lastCompletedCheck === 'string' || typeof lastCompletedCheck === 'number') {
              setLastCheckedDate(new Date(lastCompletedCheck));
            } else {
              setLastCheckedDate(null);
            }
          }
        } else {
          setLastCheckedDate(null);
        }
      } catch (error) {
        console.error("Error fetching checks:", error);
      }
    }

    subscribeToRigcheckAnswers();
  }, [agency, check.id]);

  return (
    <>
      <div className="rigcheck-card" onClick={handleCardClick}>
        <div className="header">
          <h1>
            {check.name}
          </h1>
          <div className="flex-row">
            <div
              className="icon-square"
              style={{ background: disabledService ? "red" : "green" }}
            >
              {disabledService ? "OUT OF SERVICE" : "IN SERVICE"}
            </div>
          </div>
        </div>
        <div className="details">
          <div className="detail-column">
            <div
              className="item-count"
              style={{ color: completedToday ? "white" : "red" }}
            >
              {completedToday}
            </div>
            <div className="text-description">Checks Completed Today</div>
          </div>
          <div className="detail-column">
            <div
              className="item-count"
              style={{ color: failedValue ? "#f65224" : "green" }}
            >
              {failedValue}
            </div>
            <div className="text-description">Failed</div>
          </div>
        </div>
        {hasChildChecks && (
          <div className="has-sub-checks">
            <span>Multiple checks available</span>
          </div>
        )}
        
        {/* Last Checked Flag - Only shown when there's a last checked date */}
        {lastCheckedDate && (
          <div className="last-checked-flag">
            <div className="last-checked-label">Last Checked on:</div>
            <div className="last-checked-date">
              {lastCheckedDate.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              })}
              {' '}
              {lastCheckedDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>
        )}
      </div>

      {/* Show SubCheck Modal when a parent check with child checks is clicked */}
      <SubCheckModal
        open={modalOpen}
        handleClose={handleCloseModal}
        parentCheck={check}
        agency={agency}
      />
    </>
  );
};

export default SingleRigcheck;
